import { Link } from './models'

export enum ClipboardType {
  RICH_LINK = 'application/x-ctrl-rich-link',
}

export interface RichLinkClipboardItem {
  caption: string
  link:    Link
}